import $api from "@/core/services/ApiService";
import {
  BankAccount,
  CreateBankAccount,
} from "@/core/services/api/interfaces/manager/BankAccount";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { TransmissionProtocol } from "@/core/services/api/interfaces/manager/TransmissionProtocol";
import { LegalType } from "@/core/services/api/interfaces/common/LegalType";
import { TransferService } from "@/core/services/api/interfaces/dict/CreateTransactionPage";

class BankAccountEndpoint {
  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get(`manager/bank-accounts`, params);
  }

  public view(id: number): Promise<AxiosResponse> {
    return $api.get(`manager/bank-accounts/${id}`);
  }

  public selectDefault(account: BankAccount): Promise<AxiosResponse> {
    return $api.put(`manager/bank-accounts/${account.id}/selected`);
  }

  public create(data: CreateBankAccount): Promise<AxiosResponse> {
    return $api.post("manager/bank-accounts", data);
  }

  public validateBalance(
    amount: number,
    bank_account_id: number,
    customer_legal_type: LegalType | null,
    transmission_protocol_id: TransmissionProtocol,
    params: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    if (!("params" in params)) {
      params.params = {};
    }
    params.params["amount"] = amount;
    params.params["bank_account_id"] = bank_account_id;
    params.params["customer_legal_type"] = customer_legal_type;
    params.params["transmission_protocol_id"] = transmission_protocol_id;

    return $api.get(
      `manager/bank-accounts/${bank_account_id}/validate-balance`,
      params
    );
  }

  public calculateGrandTotal(
    request: {
      amount: number;
      bank_account_id: number;
      to_account_id: number | null;
      customer_legal_type?: LegalType | null;
      transfer_service?: TransferService | null;
      customer_iban?: string | null;
      customer_account?: string | null;
      bank_swift?: string | null;
      sort_code?: string | null;
    },
    params: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    if (!("params" in params)) {
      params.params = {};
    }
    params.params["amount"] = request.amount;
    params.params["bank_account_id"] = request.bank_account_id;
    params.params["customer_legal_type"] = request.customer_legal_type;
    params.params["to_account_id"] = request.to_account_id;
    params.params["transfer_service"] =
      "transfer_service" in request ? request.transfer_service : null;
    params.params["customer_iban"] =
      "customer_iban" in request ? request.customer_iban : null;
    params.params["customer_account"] =
      "customer_account" in request ? request.customer_account : null;
    params.params["bank_swift"] =
      "bank_swift" in request ? request.bank_swift : null;
    params.params["sort_code"] =
      "sort_code" in request ? request.sort_code : null;

    return $api.get(`manager/transactions/grand-total`, params);
  }

  public downloadReferenceLetter(
    bankAccount: BankAccount,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    params.responseType = "blob";

    return $api.get(
      `manager/bank-accounts/${bankAccount.id}/reference-letter`,
      params
    );
  }
}

export default BankAccountEndpoint;
